import { computed } from 'vue';
import { NETWORK_SUPPORTS_CHARTS } from './supporting-features-in-network';

export const isAnalyticNetworkSupported = computed(() => NETWORK_SUPPORTS_CHARTS);
